import { FormFieldType } from '../../modules/forms/enums/FormFieldType'

export function isSpecialType(type: FormFieldType) {
  const specialTypes = [FormFieldType.MultiSelect, FormFieldType.RadioButton, FormFieldType.Select]
  return specialTypes.includes(type)
}
